import WatchAccess from './WatchAccess'

export default WatchAccess
// eslint-disable-next-line import/export
export * from './WatchAccess'
